import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/partners/go-watts.png'
import _imports_1 from '@/assets/images/socials/facebook-white.svg'
import _imports_2 from '@/assets/images/socials/website.svg'
import _imports_3 from '@/assets/images/partners/groep-coenen.png'


const _withScopeId = n => (_pushScopeId("data-v-2ebbf667"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "partners" }
const _hoisted_2 = { id: "partners-container" }
const _hoisted_3 = {
  class: "section-top-text",
  id: "partners-top-text"
}
const _hoisted_4 = {
  class: "section-sub-text",
  id: "partners-sub-text"
}
const _hoisted_5 = { id: "partners-card-container" }
const _hoisted_6 = {
  id: "go-watts",
  class: "partner-card"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"image-container\" data-v-2ebbf667><img class=\"partner-logo\" src=\"" + _imports_0 + "\" alt=\"Go Watts logo\" data-v-2ebbf667><div class=\"overlay\" data-v-2ebbf667><a href=\"https://www.facebook.com/gowatts\" target=\"_blank\" data-v-2ebbf667><img width=\"30\" src=\"" + _imports_1 + "\" alt=\"Groep Coenen logo\" data-v-2ebbf667></a><a href=\"https://gowatts.be\" target=\"_blank\" data-v-2ebbf667><img width=\"25\" src=\"" + _imports_2 + "\" alt=\"Groep Coenen logo\" data-v-2ebbf667></a></div></div>", 1)
const _hoisted_8 = { class: "partner-info-container" }
const _hoisted_9 = { class: "partner-name" }
const _hoisted_10 = { class: "partner-description" }
const _hoisted_11 = {
  class: "visit-website",
  href: "https://gowatts.be",
  target: "_blank"
}
const _hoisted_12 = {
  id: "groep-coenen",
  class: "partner-card"
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"image-container\" data-v-2ebbf667><img class=\"partner-logo\" id=\"coenen-logo\" src=\"" + _imports_3 + "\" alt=\"Groep Coenen logo\" data-v-2ebbf667><div class=\"overlay\" data-v-2ebbf667><a href=\"https://www.coenen.be\" target=\"_blank\" data-v-2ebbf667><img width=\"25\" src=\"" + _imports_2 + "\" alt=\"Groep Coenen logo\" data-v-2ebbf667></a></div></div>", 1)
const _hoisted_14 = { class: "partner-info-container" }
const _hoisted_15 = { class: "partner-name" }
const _hoisted_16 = { class: "partner-description" }
const _hoisted_17 = {
  class: "visit-website",
  href: "https://www.coenen.be",
  target: "_blank"
}

import {getCurrentInstance} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnersView',
  setup(__props) {


const instance = getCurrentInstance();
const translator = instance?.appContext.config.globalProperties.$translatorUtils;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(translator).trans("general.partners.top_text")), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translator).trans("general.partners.sub_text")), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(translator).trans("general.partners.go_watts.name")), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(translator).trans("general.partners.go_watts.description")), 1)
          ]),
          _createElementVNode("a", _hoisted_11, _toDisplayString(_unref(translator).trans("general.partners.go_watts.visit_website")), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h3", _hoisted_15, _toDisplayString(_unref(translator).trans("general.partners.groep_coenen.name")), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(translator).trans("general.partners.groep_coenen.description")), 1)
          ]),
          _createElementVNode("a", _hoisted_17, _toDisplayString(_unref(translator).trans("general.partners.groep_coenen.visit_website")), 1)
        ])
      ])
    ])
  ]))
}
}

})